import DashboardGenComponent from "@/components/DashboardGenComponent.tsx";
import st from "@/styles/CreditPage.module.scss";
import React, {useLayoutEffect} from "react";
import {useTranslation} from "react-i18next";
import CommonClass from "@/utils/common";
import SimpleCopyButton from "@/ui/SimpleCopyButton.tsx";
import {useNavigate, useParams} from "react-router-dom";
import LoanInterface from "@/types_and_interfaces/loan_interface.ts";
import useCommon from "@/hooks/common.ts";
import useLoans from "@/hooks/loans.ts";
import clsx from "clsx";
import {isMobile} from "react-device-detect";
import Button from "@/ui/Button.tsx";
import eventEmitter from "@/utils/event_emmiter_instance.ts";
import DividerSimple from "@/ui/DividerSimple.tsx";
import {penalty_amount} from "@/utils/constants.ts";
import DashboardClass from "@/utils/dashboard_class.ts";
import CrLineTransactionInterface from "@/types_and_interfaces/cr_line_transaction_interface.ts";
import PaymentHistory from "@/components/PaymentHistory.tsx";
import StaticRangeSlider from "@/ui/StaticRangeSlider.tsx";
import {DashboardHeaderType} from "@/types_and_interfaces/types.ts";
import LoginLoader from "@/ui/LoginLoader.tsx";



const CrLineTransaction:React.FC = () => {
    
    const {urn} = useParams()
    const loans = useLoans()
    const {t} = useTranslation()
    const credit:CrLineTransactionInterface | undefined = loans.getCrLineTransaction(urn as string)
    const credit_l_arr = loans.getLoansByType("Credit Line")?.filter((x) => x.r_status === "approved")
    const credit_l:LoanInterface | undefined = (Array.isArray(credit_l_arr) && credit_l_arr.length) ? loans.get_last_cr_line() : undefined
    const transaction_payments = credit_l?.payments?.filter((x) => x.urn === credit?.urn_tr)
    const total_paid = transaction_payments?.reduce((sum, item) => sum + Number(item.amount), 0) || 0
    const is_cr_undefined = typeof credit === "undefined"
    const common_hook = useCommon()

    // cr_date.setMonth(cr_date.getMonth() + (credit ?  credit?.nr_of_installments : 0));
    
    const header_type_handle  = ():DashboardHeaderType => {
        
        if (credit === undefined) return "gray"
        
        if(credit?.restant && !credit.fully_paid) {
            return "danger"
        } else return "primary"
    }

    useLayoutEffect(() => {
        // backUrlHandler()
        
        return () => {
            localStorage.removeItem(CommonClass.local_storage_fields.back_url)
        }
    }, []);
    
    return (
        <DashboardGenComponent
            
            responsive1
            
            backUrl={DashboardClass.dashboard_routes.CreditLine}
            
            header_type={header_type_handle()}
            
            heading={
                <div className={st.heading}>
                    {t("credit_details")} <span> {t("contract_nr1")} {urn} </span>
                </div>
            }
            
            header_content={
                <div
                    style={{padding:is_cr_undefined ? "0" : "16px" }}
                    className={clsx(st.header_content,  st.is_cr_line)}
                >
                    
                    {is_cr_undefined ? (
                        <LoginLoader className={st.loader} />
                    ) : (
                        <>
                            
                            <div className={st.center}>
                                
                                <div>
                                    <span>
                                        {t("credit_amount")}
                                    </span>
                                    <strong>
                                        {CommonClass.formatMoneyAmount(Number(credit?.amount))} {t("currency")}
                                    </strong>
                                </div>
                                

                                <div>
                                    <span>
                                        {t("contract_nr")}
                                    </span>
                                    
                                    <strong
                                        style={{
                                            textDecoration: isMobile ? "underline" : "none"
                                        }}
                                        onClick={() => {
                                            common_hook.copyToClipboard(credit?.urn_tr)
                                        }}
                                    >
                                        {credit?.urn_tr}
                                    </strong>
                                    
                                    {!isMobile && (
                                        <SimpleCopyButton
                                            className={st.copy}
                                            value={credit.urn_tr}
                                        />
                                    )}
                                
                                </div>
                            
                            </div>

                            <StaticRangeSlider
                                max={Number(credit?.amount)}
                                value={total_paid}
                                danger={credit?.restant && !credit.fully_paid}
                                
                            />
                            
                        </>
                    )}
                
                </div>
            }
            
            column_center={
                <div className={st.column_center}>

                    {typeof credit_l !== undefined ? (
                        <Pay credit={credit_l}  mobile/>
                    ) : null}

                    <PaymentHistory
                        payments={transaction_payments}
                    />
                    
                </div>
            }
            
            column_right={
                <>
                    {typeof credit_l !== undefined ? (
                        <Pay credit={credit_l} />
                    ) : null}
                </>
                // <></>
            }
        
        />
    )
}

interface PayProps {
    credit: LoanInterface | undefined
    mobile?: boolean
}

const Pay:React.FC<PayProps> = ({credit, mobile}) => {
    const {t} = useTranslation()
    const penalities = (credit?.restant_days || 0) * penalty_amount
    const total = penalities + Number(credit?.inst_amount)
    const navigate = useNavigate()

    const pay_funct = (all?:string) => {
        if(window.innerWidth > CommonClass.breakpoints.breakpoint2) {
            navigate(DashboardClass.dashboard_routes.Banks+"/"+ credit?.urn + "/" + all || "0")
        } else {
            eventEmitter.emit(CommonClass.ModalEvents.PayCreditModalOpen, {credit, all})
        }
    }

    return (
        <div className={clsx(st.column_right, mobile ? st.mobile : st.desktop)}>

            {credit?.restant_days ? (
                <span className={st.danger}>
                    {t("restant1").replace("{{days}}", String(credit?.restant_days)) + t(CommonClass.time_word_handling(credit?.restant_days))}
                </span>
            ) : null}

            {credit?.restant_days ? (

                <>
                    <div className={st.row}>
                        <span>
                            {t("to_pay")}
                        </span>

                        <span className={st.dark}>
                            {`${CommonClass.formatMoneyAmount(Number(credit?.inst_amount))} ${t("currency")}` }
                        </span>
                    </div>

                    <DividerSimple />
                </>
            ) : null}


            {credit?.restant_days ? (
                <>
                    <div className={st.row}>
                        <span>
                            {t("penalities")}
                        </span>

                        <span className={st.danger}>
                            {`+ ${CommonClass.formatMoneyAmount(penalities)} ${t("currency")}`}
                        </span>

                        <span className={st.small}>
                            {t("penality_info").replace("{{penality}}", String(penalty_amount.toFixed(2)) + "(hard)")}
                        </span>
                    </div>

                    <DividerSimple />
                </>
            ) : null}
            
            <span>
                {credit?.restant_days ? t("total") : t("to_pay")}
            </span>

            <strong>{CommonClass.formatMoneyAmount(total) + " " + t("currency")}</strong>

            <div className={st.controllers}>

                <Button
                    onClick={() => pay_funct("0")}
                    className={st.button_pay}
                >
                    {t("pay")}
                </Button>

                <Button
                    outlined
                    className={st.anticipat_pay}
                    onClick={() => pay_funct("1")}
                >
                    {t("anticipat_pay")}
                    <br/>
                    {CommonClass.formatMoneyAmount(Number(credit?.capital)) + " " + t("currency")}
                </Button>

            </div>
            
            {!credit && (
                <LoginLoader className={st.loader} />
            )}
        </div>
    )
}


export default CrLineTransaction